import React from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "@/i18n/LanguageContext";
import SEO from "@/components/site/SEO";

const NotFound = () => {
  const { t } = useLanguage();

  return (
    <div className="min-h-[70vh] flex items-center justify-center pt-32 pb-16">
      <SEO title={t("notFound.seoTitle")} noIndex />
      <div className="text-center px-6">
        <div className="font-display text-8xl md:text-9xl font-black text-maroon-800/20 tracking-tighter">404</div>
        <h1 className="mt-4 text-3xl md:text-4xl font-display font-bold text-zinc-900">{t("notFound.title")}</h1>
        <p className="mt-3 text-zinc-600">{t("notFound.body")}</p>
        <Link to="/" data-testid="notfound-home" className="mt-8 inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-maroon-800 text-white font-semibold hover:bg-maroon-900">
          {t("common.backHome")}
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
